export default __webpack_public_path__ + "static/media/error.d83f1e09.svg";